import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { isOrderReplaced } from "../../utils/orderInfo";
import { Bold } from "../common/Bold";
export var DamageMissingIA = function DamageMissingIA(_ref) {
  var context = _ref.context;
  var isReplacement = isOrderReplaced(context);
  if (isReplacement) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "LZxyBC",
      defaultMessage: "When a retailer marks an item as missing or damaged, you\u2019ll receive both an email and a notification on the <OrderLinkFormatting>order details page</OrderLinkFormatting>. This report will indicate the items and quantities marked as missing or damaged. For items marked damaged, there will also be photos of the damage. These items are automatically removed from the retailer\u2019s invoice.",
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder, _context$brandOrder$b;
          return _OrderLinkFormatting(chunks, (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: "If you feel that a retailer has incorrectly marked an item as missing or damaged, you can dispute the report."
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: "For next day payment terms, you can dispute directly through the <BoldFormatting>issue report</BoldFormatting> on the <OrderLinkFormatting>order details page</OrderLinkFormatting>. For any other payout options, you can contact our support team for more assistance with a dispute.",
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder2, _context$brandOrder2$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "b3fCmJ",
      defaultMessage: "When a retailer marks an item as missing or damaged, you\u2019ll receive both an email and a notification on the <OrderLinkFormatting>order details page</OrderLinkFormatting>. This report will indicate the items and quantities marked as missing or damaged. For items marked damaged, there will also be photos of the damage. These items are automatically removed from the retailer\u2019s original invoice and deducted from your payout. ",
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder3, _context$brandOrder3$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder3 = context.brandOrder) === null || _context$brandOrder3 === void 0 ? void 0 : (_context$brandOrder3$ = _context$brandOrder3.brand_order) === null || _context$brandOrder3$ === void 0 ? void 0 : _context$brandOrder3$.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+plhEc",
      defaultMessage: "If the retailer has requested replacements for these items, you\u2019ll see a new order created automatically on the <BoldFormatting>Orders</BoldFormatting> page. Once you fulfill the new replacement order, you\u2019ll receive a separate payout.",
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: "If you feel that a retailer has incorrectly marked an item as missing or damaged, you can dispute the report."
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: "For next day payment terms, you can dispute directly through the <BoldFormatting>issue report</BoldFormatting> on the <OrderLinkFormatting>order details page</OrderLinkFormatting>. For any other payout options, you can contact our support team for more assistance with a dispute.",
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder4, _context$brandOrder4$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder4 = context.brandOrder) === null || _context$brandOrder4 === void 0 ? void 0 : (_context$brandOrder4$ = _context$brandOrder4.brand_order) === null || _context$brandOrder4$ === void 0 ? void 0 : _context$brandOrder4$.token);
        }
      }
    })));
  }
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};